export default __webpack_public_path__ + "static/Sem-desperdicio-c87ceb4d23eccf8c2261caa4cf54fc8b.svg";